import React from 'react';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';
import { Lock } from '@mui/icons-material';

interface EmptyStateProps {
  isLoading?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ isLoading = false }) => {
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
          py: 8,
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={60} />
          <Typography variant="h6" sx={{ mt: 3, color: 'text.secondary' }}>
            Loading your applications...
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        py: 8,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          textAlign: 'center',
          p: 6,
          maxWidth: 500,
          backgroundColor: 'grey.50',
          borderRadius: 3,
        }}
      >
        <Box
          sx={{
            display: 'inline-flex',
            p: 3,
            borderRadius: '50%',
            backgroundColor: 'primary.main',
            color: 'white',
            mb: 3,
          }}
        >
          <Lock sx={{ fontSize: 48 }} />
        </Box>
        
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
          Access Required
        </Typography>
        
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 4, lineHeight: 1.6 }}
        >
          You don't currently have access to any applications. To request access to
          MarketCompass reports and other features, please contact your administrator
          or IT support team.
        </Typography>
        
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', mt: 3 }}
        >
          Your access permissions are managed by your organization's administrator
        </Typography>
      </Paper>
    </Box>
  );
};